import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';

interface AutoClosedNoteBannerProps {
  message: string;
}

export const AutoClosedNoteBanner = ({ message }: AutoClosedNoteBannerProps) => {
  const trimmed = message.trim();
  if (!trimmed) return null;

  const prefixMatch = trimmed.match(/^Note:\s*/i);
  const body = prefixMatch ? trimmed.slice(prefixMatch[0].length) : trimmed;

  return (
    <Box bg="ats-bg-primary" borderRadius="sm" p="14px" mb="6px">
      {prefixMatch ? (
        <KText size="sm-regular" color="secondary-900">
          <KText as="span" size="sm-semi-bold">
            Note:
          </KText>
          {body ? ` ${body}` : null}
        </KText>
      ) : (
        <KText size="sm-regular" color="secondary-900">
          {trimmed}
        </KText>
      )}
    </Box>
  );
};
